export default "__VITE_ASSET__CI4LJKG5__"